require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-c-cgqu.json") })
        }
      }, "path---photos-professional-c-cgqu");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-c-cgqu!./.cache/json/photos-professional-c-cgqu.json
// module id = 718
// module chunks = 231608221292675